export default "__VITE_ASSET__BumJ_o4___"